module.exports = __webpack_public_path__ + "img/international.b76427d3.svg";